import { useMemo } from "react";
import { RectShadowMaterial } from "../../materials/RectShadowMaterial";

const PointerShadow = ({
  width = 3,
  height = 1,
  opacity = 0.35,
  softness = 0.8,
}) => {
  const aspect = useMemo(() => {
    // Вычисляем aspect ratio для правильной формы эллипса
    // Используем width/height напрямую для создания эллипса, вписанного в прямоугольник
    // Нормализуем относительно height для правильного масштабирования
    return [width / height, 1.0];
  }, [width, height]);

  const material = useMemo(
    () => new RectShadowMaterial(opacity, softness, aspect),
    [opacity, softness, aspect]
  );

  return (
    <mesh
      rotation={[-Math.PI / 2, 0, 0]}
      position={[0, -0.98, 0]}
      renderOrder={-1}
    >
      <planeGeometry args={[width, height, 64, 64]} />
      <primitive object={material} attach="material" />
    </mesh>
  );
};

export default PointerShadow;
